export default "__VITE_ASSET__CaI4ERfe__"